import React from "react";

// Icons
import TwitterBlack from "assets/icons/social-media/TwitterBlack.png";
import FacebookBlack from "assets/icons/social-media/FacebookBlack.png";
import LinkedInBlack from "assets/icons/social-media/LinkedInBlack.png";
import MessageBlack from "assets/icons/social-media/MessageBlack.png";
import UrlBlack from "assets/icons/social-media/UrlBlack.png";

const ShareUsingSocialMedia = ({
  twitterURL,
  facebookURL,
  linkedinURL,
  mailSubject,
  mailContent,
  copyLink,
}) => {
  return (
    <div className="flex flex-wrap justify-center gap-3 sm:justify-start sm:gap-4">
      {/* Facebook */}
      <a
        href={`https://www.facebook.com/sharer/sharer.php?u=${facebookURL}&quote=Check%20ISA%20Blog!"`}
        target="_blank"
        rel="noreferrer"
        className="flex items-center justify-center transition duration-500 ease-in-out border border-black rounded-full w-9 h-9 sm:w-10 sm:h-10 md:w-12 md:h-12 hover:bg-black group"
      >
        <img
          src={FacebookBlack}
          alt="Facebook"
          className="w-4 h-auto transition duration-500 ease-in-out sm:w-5 md:w-6 group-hover:invert"
        />
      </a>

      {/* Twitter */}
      <a
        href={`https://twitter.com/intent/tweet?text=Check%20ISA%20Blog!&url=${twitterURL}`}
        target="_blank"
        rel="noreferrer"
        className="flex items-center justify-center transition duration-500 ease-in-out border border-black rounded-full w-9 h-9 sm:w-10 sm:h-10 md:w-12 md:h-12 hover:bg-black group"
      >
        <img
          src={TwitterBlack}
          alt="Twitter"
          className="w-4 h-auto transition duration-500 ease-in-out sm:w-5 md:w-6 group-hover:invert"
        />
      </a>

      {/* LinkedIn */}
      <a
        href={`https://www.linkedin.com/sharing/share-offsite/?url=${linkedinURL}`}
        target="_blank"
        rel="noreferrer"
        className="flex items-center justify-center transition duration-500 ease-in-out border border-black rounded-full w-9 h-9 sm:w-10 sm:h-10 md:w-12 md:h-12 hover:bg-black group"
      >
        <img
          src={LinkedInBlack}
          alt="LinkedIn"
          className="w-4 h-auto transition duration-500 ease-in-out sm:w-5 md:w-6 group-hover:invert"
        />
      </a>

      {/* Gmail */}
      <a
        href={`https://mail.google.com/mail/u/0/?view=cm&to&su=${mailSubject}&body=${mailContent}%0A&bcc&cc&fs=1&tf=1`}
        target="_blank"
        rel="noreferrer"
        className="flex items-center justify-center transition duration-500 ease-in-out border border-black rounded-full w-9 h-9 sm:w-10 sm:h-10 md:w-12 md:h-12 hover:bg-black group"
      >
        <img
          src={MessageBlack}
          alt="Gmail"
          className="w-4 h-auto transition duration-500 ease-in-out sm:w-5 md:w-6 group-hover:invert"
        />
      </a>

      {/* Copy link */}
      <a
        href="#"
        onClick={copyLink}
        className="flex items-center justify-center transition duration-500 ease-in-out border border-black rounded-full w-9 h-9 sm:w-10 sm:h-10 md:w-12 md:h-12 hover:bg-black group"
      >
        <img
          src={UrlBlack}
          alt="Copy link"
          className="w-4 h-auto transition duration-500 ease-in-out sm:w-5 md:w-6 group-hover:invert"
        />
      </a>
    </div>
  );
};

export default ShareUsingSocialMedia;
